const BASE_URL = "https://xpanel.s-bar.ir/"

export default {
    BASE_URL: BASE_URL,
}